export enum SimpleMathFormatting  {
    No = "No formatting",
    Comma = "Format with comma as decimal",
    Dot = "Format with dot as decimal"
}